module.exports = __webpack_public_path__ + "img/jordan.9c5cb858.png";